import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { getFixedAssetsColumns } from "../../../data/DynamicTable/Collumns";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../config";
import {
  allFixedAssets,
  fixedAssetsCategories,
  allAssetTypes,
  allDepreciationMethods,
  allDepreciationSchedules,
} from "../../../data/Columns/Queries/FixedAssetManagement/fixedAssetsmanagement";
import FixedAssetForm from "./form";
import { graphqlQuery } from "../../../data/Axios/DynamicService";

const base_url = AccountsandFinanceurl.uri;

const FixedAssets = () => {
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [methods, setMethods] = useState([]);
  const [schedules, setSchedules] = useState([]);

  useEffect(() => {
    const fetchLookups = async () => {
      try {
        const [catData, typeData, methodData, scheduleData] = await Promise.all([
          graphqlQuery(fixedAssetsCategories, base_url),
          graphqlQuery(allAssetTypes, base_url),
          graphqlQuery(allDepreciationMethods, base_url),
          graphqlQuery(allDepreciationSchedules, base_url),
        ]);
        setCategories(catData || []);
        setTypes(typeData || []);
        setMethods(methodData || []);
        setSchedules(scheduleData || []);
      } catch (error) {
        console.error("Error fetching lookups:", error);
      }
    };
    fetchLookups();
  }, []);

  const columns = getFixedAssetsColumns(categories, types, methods, schedules);

  const actions = {
    entity: "Fixed Assets",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: true,
      permission: "ActivatePermission",
      inputObjectName: "activateDeactivateFixedAsset",
    },
    showStatus: true,
  };

  return (
    <Box m="10px">
      <DynamicTable
        title="Fixed Assets"
        subtitle="Fixed Assets List"
        columns={columns}
        FormComponent={FixedAssetForm}
        query={allFixedAssets}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default FixedAssets;